import React, { useState } from 'react';

function ContactForm() {
  const [name, setName] = useState('');
  const [email, setEamil] = useState('');
  const [message, setMessage] = useState('');
  return (
    <form action="#" className="contact-form">
      <h3 className="form-heading heading-2 white mb-20">Send a request</h3>
      <input
        type="text"
        placeholder="Your name"
        className="form-field"
        required
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <input
        type="email"
        placeholder="Your email"
        className="form-field"
        required
        value={email}
        onChange={(e) => setEamil(e.target.value)}
      />
      <textarea
        placeholder="Message"
        className="form-text-field"
        required
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />
      <button type="button" className="button button-primary mt-10">
        Send Message
      </button>
    </form>
  );
}

export default ContactForm;
